import { type ReactNode } from 'react';
import { type SeverityType } from '@kirin/api-client/contracts/shared/severity';
import { HighlightBox } from '@/components/shared/HighlightBox';
import { SeverityBadge } from '@/components/policylist/components/SeverityBadge';
import { AlertDescription } from '@/components/grouped-alerts/AlertDescription';
import type { AlertDescriptionSections } from '@kirin/api-client/helpers/alerts';

interface AlertCardProps {
  title: string;
  severity: SeverityType;
  description: string | ReactNode;
  descriptionSections?: AlertDescriptionSections | null;
  details?: string | ReactNode;
}

export default function AlertCard({
  title,
  severity,
  description,
  descriptionSections,
  details,
}: AlertCardProps) {
  const fallbackDescription =
    typeof description === 'string' ? description : '';

  return (
    <HighlightBox variant={severity}>
      <div className="flex items-center gap-2 mb-1">
        <span className="font-semibold text-sm">{title}</span>
        <SeverityBadge riskLevel={severity} showIcon />
      </div>
      <div className="text-xs text-muted-foreground">
        {typeof description === 'string' ? (
          <AlertDescription
            sections={descriptionSections ?? null}
            fallbackDescription={fallbackDescription}
          />
        ) : (
          description
        )}
      </div>
      {details && (
        <div className="text-xs text-muted-foreground mt-1">
          {typeof details === 'string' ? <p>{details}</p> : details}
        </div>
      )}
    </HighlightBox>
  );
}
